import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { InvitationDTO, InvitationService, PageInvitationDTO } from '../../services/invitation.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-all',
  templateUrl: './all.component.html',
  styleUrls: ['./all.component.sass'],
  standalone: false
})
export class AllComponent implements OnInit {
  invitations: InvitationDTO[] = [];
  isLoading = true;
  page: PageInvitationDTO | undefined;
  pageSize = 10;
  pageIndex = 0;
  selectedStatus = 'ACTIVE';
  condominiumId: number;

  constructor(
    private invitationService: InvitationService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.condominiumId = +this.route.parent!.snapshot.paramMap.get('id')!;
    this.loadInvitations();
  }

  loadInvitations(): void {
    this.isLoading = true;
    // TODO: tratar erro
    this.invitationService.getAllInvitations(this.condominiumId, this.selectedStatus, this.pageIndex, this.pageSize)
      .subscribe({
        next: response => {
          this.page = response;
          this.invitations = response.content;
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
          this.snackBar.open('Ocorreu um erro ao carregar os convites.', 'Fechar', {
            duration: 4000,
            panelClass: ['mat-warn']
          });
        }
      });
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadInvitations();
  }

  onStatusChange(status: string): void {
    this.selectedStatus = status;
    this.pageIndex = 0;
    this.loadInvitations();
  }

  openCreateInvitationDialog(): void {
    this.router.navigate(['/condominium', this.condominiumId, 'invitation', 'create']);
  }

  deleteInvitation(invitationId: number): void {
    this.invitationService.deleteInvitation(invitationId).subscribe(() => {
      this.loadInvitations();
    });
  }
}
